import { createTheme, Theme } from '@mui/material/styles';

// Define your custom light theme
const theme: Theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#74a489', // Green primary color
      light: '#8fb49a',
      dark: '#5a7d6a',
    },
    secondary: {
      main: '#a6bdc5', // Blue-gray secondary color
      light: '#b8c9d0',
      dark: '#8a9ca4',
    },
    background: {
      default: '#f6f9f7', // Light green-tinted background
      paper: '#f2f5f6',   // Very light version of secondary color for cards and papers
    },
    text: {
      primary: '#0e1511',   // Dark green text
      secondary: '#4a5a4e', // Medium green for secondary text
    },
    info: {
      main: '#93a0b8',  // Accent color for info
      light: '#e8ecf3',  // Very light blue-gray for info backgrounds
    },
    error: {
      main: '#c75656',  // Softer red that fits the theme
      light: '#d47373',
      dark: '#a04444',
    },
    warning: {
      main: '#ed6c02', // Standard warning orange
    },
    success: {
      main: '#74a489', // Use primary green for success
    },
    divider: '#e0e7e1', // Light green-tinted divider
  },
  typography: {
    h4: {
      fontWeight: 600,
      marginBottom: '1rem',
      color: '#0e1511',
    },
    h6: {
      fontWeight: 500,
      color: '#0e1511',
    },
    body1: {
      color: '#0e1511',
    },
    body2: {
      color: '#4a5a4e',
    },
  },
  components: {
    MuiPaper: {
      defaultProps: {
        elevation: 4,
      },
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundImage: 'none',
          border: '1px solid #e0e7e1',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(116, 164, 137, 0.15)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          border: '1px solid #e0e7e1',
          backgroundImage: 'none',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#e0e7e1',
            },
            '&:hover fieldset': {
              borderColor: '#74a489',
            },
          },
        },
      },
    },
  },
});

export default theme; 